import PropTypes from 'prop-types'
import React from 'react'
import {
  FormGroup,
  HelpBlock
} from 'react-bootstrap'
import RichTextEditor from '../Editor'

export class FormField extends React.Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    richTextEditorProps: PropTypes.object.isRequired,
    errorOnTouched: PropTypes.bool,
    style: PropTypes.object
  }

  static defaultProps = {
    errorOnTouched: true,
    richTextEditorProps: {}
  }

  render () {
    const {
      input,
      meta,
      richTextEditorProps,
      errorOnTouched,
      style
    } = this.props

    const hasError =
      errorOnTouched
      ? meta.touched && meta.error
      : meta.error

    const onChange = (content) => {
      input.onChange(content)

      richTextEditorProps.onChange && richTextEditorProps.onChange(content)
    }

    const onFocus = (event) => {
      input.onFocus(event)

      richTextEditorProps.onFocus && richTextEditorProps.onFocus(event)
    }

    const onBlur = (event) => {
      input.onBlur(event)

      richTextEditorProps.onBlur && richTextEditorProps.onBlur(event)
    }

    return (
      <FormGroup
        style={{
          width: '100%',
          margin: 0,
          ...style
        }}
        validationState={hasError ? 'error' : null}>
        <RichTextEditor
          {...input}
          {...richTextEditorProps}
          error={meta.error}
          submitting={meta.submitting}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur} />
        {hasError && <HelpBlock>{meta.error}</HelpBlock>}
      </FormGroup>
    )
  }
}

export default FormField
